export const FONT_SIZES = {
  superSmall: '12px',
  small: '14px',
  regular: '16px',
  medium: '18px',
  superMedium: '20px',
  large: '24px',
  smallLarge: '28px',
  mediumLarge: '32px',
  avgLarge: '40px',
  veryLarge: '48px',
  superLarge: '64px',
  superMediumLarge: '76px',
  superVeryLarge: '80px',
};

export const FONTS = {
  SIZE: FONT_SIZES,
};
